import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiStatus } from '../utils/constants';
import api from '../utils/api';

export const loginUser = createAsyncThunk('user/login', async (params, thunkAPI) => {
  try {
    const response = await api.post('/user/logins', params);
    return response;
  } catch (e) {
    console.log(e);
    return thunkAPI.rejectWithValue(e);
  }
});

export const authSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    token: null,
    status: ApiStatus.idle,
    errorMessage: '',
    isAuthenticated: false
  },
  reducers: {
    load(state) {
      state.user = JSON.parse(localStorage.getItem('user'));
      state.token = localStorage.getItem('token');
      if (!state.token) {
        console.log('Not Logged in...');
        state.isAuthenticated = false;
        state.status = ApiStatus.failed;
      } else {
        console.log('Logged in...');
        state.isAuthenticated = true;
        state.status = ApiStatus.success;
      }
    },
    logout(state) {
      console.log('Logging out...');
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.status = ApiStatus.success;
    }
  },
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.user = payload.user;
      state.token = payload.token;
      state.status = ApiStatus.success;
      state.isAuthenticated = true;
      return state;
    },
    [loginUser.rejected]: (state, props) => {
      state.errorMessage = props.payload.error;
      state.status = ApiStatus.failed;
      state.isAuthenticated = false;
    },
    [loginUser.pending]: (state) => {
      state.status = ApiStatus.loading;
    }
  }
});

export const { load, logout } = authSlice.actions;
export const authSelector = (state) => state.user;
